<input #color type="color" [formControl]="control" />
